import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S12};
  padding: ${Spacing.S12} ${Spacing.S16};
`

export const MessageWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: ${Spacing.S16};
`

export const MessageContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S4};
`
